import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useWavesurfer } from '@wavesurfer/react';
import { FaPause, FaPlay, FaStop } from 'react-icons/fa';

// Icons
import Button from '../CustomButton';

// Styles
import styles from './style.module.scss';

interface AudioPlayerProps {
  audioUrl: string;
  withWaveform?: boolean;
}

const AudioPlayer: React.FC<AudioPlayerProps> = ({ audioUrl, withWaveform = false }) => {
  // Refs
  const waveformContainerRef = useRef<HTMLDivElement>(null);

  const { wavesurfer, isPlaying } = useWavesurfer({
    container: waveformContainerRef,
    url: audioUrl,
    height: 42,
    barWidth: 4,
    barGap: 2,
    barRadius: 2,
    barHeight: 3,
    waveColor: '#C9CDD8',
    progressColor: '#008CFF',
    fillParent: true,
    cursorWidth: 0,
  });

  const handlePlayPause = useCallback(() => {
    if (!wavesurfer) return;

    if (isPlaying) {
      wavesurfer.pause();
      wavesurfer.seekTo(0);
    } else wavesurfer.play();
  }, [wavesurfer, isPlaying]);


  return (
    <div className={styles.root}>
      <div className={styles.audio_player_button}>
        <Button variant='text' onClick={handlePlayPause}>
          {isPlaying ? <FaStop /> : <FaPlay />}
        </Button>
      </div>

      {withWaveform && (
        <div ref={waveformContainerRef} className={styles.waveform_container} />
      )}
    </div >
  )
}

export default AudioPlayer;
